module.exports = __webpack_public_path__ + "img/add.57a5ea83.png";